import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ScrollbarModule } from '../scrollbar/scrollbar.module';
import { SelectPanelComponent } from './select-panel.component';

@NgModule({
  declarations: [SelectPanelComponent],
  exports: [SelectPanelComponent],
  entryComponents: [SelectPanelComponent],
  imports: [CommonModule, FormsModule, AngularSvgIconModule, TranslateModule, ScrollbarModule]
})
export class SelectPanelModule {}

export { SelectPanelComponent };

export { SelectGroup } from './select-panel.types';
